import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_INCOME_TAX_LIST } from '../urls'
import ManthlyIncomeTaxForm from './ManthlyIncomeTaxForm'

export default function ManthlyIncomeTaxCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: MANTHLY_INCOME_TAX_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyIncomeTaxForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
